function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// @ts-strict-ignore
/** @jsx jsx */
/** @jsxFrag null */
import { jsx, ParamComponent } from 'panel';
import { defineAndMakeJsxFactory } from 'common/util/jsx';
import { panel2react } from 'common/util/react';
import { ButtonEl } from 'common/components/button';
import { SvgIconEl } from 'common/components/svg-icon';
import { IconSizeType } from 'common/constants';
import { SelectEl } from 'common/components/select';
import { getEntityCreatorDisplayName } from 'common/report/stores/user-details';
import { userCookieUtils } from 'common/report/util/user-identity-from-cookie';
import { SelectTheme } from 'common/components/select/constants';
import { ButtonTheme } from 'common/components/button/constants';
import { MixpanelUserItem } from '../user-list/types';
import { UserListEl } from '../user-list';
import { UserIconEl } from '../user-icon';
import css from './index.inline.styl';
export type UserSelectorParams = {
  users?: MixpanelUserItem[];
  selectedUsers?: string[];
  icon?: string;
  label?: string;
  searchPlaceholder?: string;
  singleSelect?: boolean;
  disableSelect?: boolean;
  hasSaveButton?: boolean;
  buttonTriggerText?: string;
  onSelectedUsersChange?: (d) => void;
  onMenuChange?: (d) => void;
  saveClicked?: () => void;
  buttonStyleOverride?: string;
};
export type JsxProps = {
  params: UserSelectorParams;
};
// users that are selected after menu close/open
type UserSelectorState = {
  committedSelectedUsers?: string[];
};
const UsersSelectTrigger = (_ref: {
  cmp: UserSelector;
}) => {
  var _cmp$params$selectedU;
  let {
    cmp
  }: {
    cmp: UserSelector;
  } = _ref;
  const selectedUsersList = cmp.getSelectedUsersList();
  let suffix = "";
  if ((selectedUsersList === null || selectedUsersList === void 0 ? void 0 : selectedUsersList.length) === 1) {
    suffix = selectedUsersList[0].name;
  }
  return <div sel='.users-select-trigger' attrs={{
    slot: "trigger"
  }} data-sentry-component="UsersSelectTrigger" data-sentry-source-file="index.tsx">
      {cmp.params.buttonTriggerText ? <ButtonEl attrs={{
      theme: ButtonTheme.Secondary,
      role: "button"
    }}>
          {cmp.params.buttonTriggerText}
        </ButtonEl> : <ButtonEl sel='.trigger-button' attrs={{
      'style-override': cmp.params.buttonStyleOverride
    }}>
          <div sel='.trigger-label'>
            {cmp.params.icon ? <SvgIconEl sel='.trigger-icon' attrs={{
          icon: cmp.params.icon
        }} /> : null}
            {cmp.params.label ? <div sel='.trigger-label-text'>{cmp.params.label}</div> : null}
            {(_cmp$params$selectedU = cmp.params.selectedUsers) !== null && _cmp$params$selectedU !== void 0 && _cmp$params$selectedU.length ? <UserListEl sel='.trigger-users' attrs={{
          users: selectedUsersList,
          size: IconSizeType.Small,
          'max-icons-displayed': 4,
          elref: "userList"
        }} /> : null}
            {suffix && <div sel='.trigger-label-suffix'>{suffix}</div>}
            <SvgIconEl sel='.trigger-caret' attrs={{
          icon: "caret-down"
        }} />
          </div>
        </ButtonEl>}
    </div>;
};
export class UserSelector extends ParamComponent<UserSelectorParams, UserSelectorState> {
  get config() {
    return {
      params: {
        users: Array,
        singleSelect: Boolean,
        selectedUsers: Array,
        icon: String,
        label: String,
        searchPlaceholder: String,
        onSelectedUsersChange: Function,
        onMenuChange: Function,
        disableSelect: Boolean,
        hasSaveButton: Boolean,
        saveClicked: Function,
        buttonTriggerText: String,
        buttonStyleOverride: String
      },
      defaultState: {
        committedSelectedUsers: [],
        singleSelect: false
      },
      css,
      useShadowDom: true,
      template: () => {
        return <div sel='.user-selector-container'>
            {this.params.disableSelect ? <UserListEl sel='.trigger-users' attrs={{
            users: this.getSelectedUsersList(),
            size: IconSizeType.Small,
            'max-icons-displayed': 4,
            elref: "userList"
          }} /> : <SelectEl sel='.user-selector' attrs={_objectSpread({
            multiple: !this.params.singleSelect,
            'multiple-save-button': this.params.hasSaveButton,
            'search-placeholder': this.params.searchPlaceholder,
            elref: "creatorSelect",
            theme: SelectTheme.Secondary
          }, this.params.buttonTriggerText ? {
            'menu-width': 300
          } : {})} props={{
            sections: this.getUserSelectorSections()
          }} on={{
            change: ev => this.params.onSelectedUsersChange(ev.detail.item),
            menuChange: ev => {
              var _this$params$onMenuCh, _this$params;
              this.update({
                committedSelectedUsers: this.params.selectedUsers
              });
              (_this$params$onMenuCh = (_this$params = this.params).onMenuChange) === null || _this$params$onMenuCh === void 0 || _this$params$onMenuCh.call(_this$params, ev.detail.isOpen);
            },
            saveClicked: this.params.saveClicked
          }}>
                <UsersSelectTrigger cmp={this} />
              </SelectEl>}
          </div>;
      }
    };
  }
  getSelectedUsersList() {
    var _this$params$users;
    return (_this$params$users = this.params.users) === null || _this$params$users === void 0 ? void 0 : _this$params$users.filter(user => this.params.selectedUsers.includes(user.email));
  }
  getUserSelectorSections() {
    var _this$params2;
    if (!((_this$params2 = this.params) !== null && _this$params2 !== void 0 && (_this$params2 = _this$params2.users) !== null && _this$params2 !== void 0 && _this$params2.length)) {
      return [];
    }
    // pushing commited selected users to top
    let items = this.params.users.filter(user => this.state.committedSelectedUsers.includes(user.email)).map(user => ({
      isSelected: this.params.selectedUsers.includes(user.email),
      label: this.getUserNameLabel(user),
      value: user.email,
      user
    }));
    items = [...items, ...this.params.users.filter(user => !this.state.committedSelectedUsers.includes(user.email)).map(user => ({
      isSelected: this.params.selectedUsers.includes(user.email),
      label: this.getUserNameLabel(user),
      value: user.email,
      user
    }))];
    return [{
      items,
      iconRenderer: item => {
        return <UserIconEl style={{
          'margin-right': "6px"
        }} attrs={{
          id: item.user.id,
          email: item.user.email,
          name: item.user.name,
          size: IconSizeType.Small,
          'disable-tooltip': true,
          'disable-sidebar': true
        }} />;
      }
    }];
  }
  connectedCallback() {
    super.connectedCallback();
  }
  getUserNameLabel(user) {
    var _userCookieUtils$getU;
    const name = getEntityCreatorDisplayName(user.email, user.name);
    return name + (((_userCookieUtils$getU = userCookieUtils.getUserIdentityFromCookie()) === null || _userCookieUtils$getU === void 0 ? void 0 : _userCookieUtils$getU.id) === user.id ? " (you)" : "");
  }
}
export const UserSelectorEl = defineAndMakeJsxFactory<JsxProps>("mp-user-selector", UserSelector);
export const UserSelectorReact = panel2react<JsxProps>("mp-user-selector", UserSelector);